var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBarGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c1ea76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9563,
    stopColor: "#a1e66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ee66a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.047,
    x2: 189.116,
    xlinkHref: "#lg1",
    y1: 360.941,
    y2: 360.941
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.572,
    x2: 294.392,
    y1: 327.116,
    y2: 327.116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2346,
    stopColor: "#fe653c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    stopColor: "#fb4628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.865,
    x2: 394.181,
    xlinkHref: "#lg2",
    y1: 292.527,
    y2: 292.527
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.794,
    x2: 478.47,
    xlinkHref: "#lg1",
    y1: 379.737,
    y2: 379.737
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.538,
    x2: 79.922,
    y1: 429.971,
    y2: 315.936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.335,
    x2: 205.614,
    y1: 394.675,
    y2: 299.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1249,
    stopColor: "#ed2819",
    stopOpacity: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    stopColor: "#d42724",
    stopOpacity: 0.452
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    stopColor: "#c5272b",
    stopOpacity: 0.753
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.558,
    x2: 379.992,
    xlinkHref: "#lg1",
    y1: 292.215,
    y2: 292.215
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.786,
    x2: 295.733,
    y1: 431.046,
    y2: 349.936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ee66a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#93e267",
    stopOpacity: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#77d660",
    stopOpacity: 0.417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7603,
    stopColor: "#49c254",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b34b"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#c1aec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.227,
    x2: 98.717,
    xlinkHref: "#lg3",
    y1: 255,
    y2: 255
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(0 1 -1 0 357.819 191.109)",
    gradientUnits: "userSpaceOnUse",
    x1: 272.374,
    x2: 363.863,
    xlinkHref: "#lg3",
    y1: 102.819,
    y2: 102.819
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.298,
    x2: 173.973,
    xlinkHref: "#lg2",
    y1: 200.783,
    y2: 85.878
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.077,
    x2: 140.35,
    xlinkHref: "#lg4",
    y1: 168.706,
    y2: 193.979
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.867,
    x2: 189.152,
    xlinkHref: "#lg5",
    y1: 205.511,
    y2: 162.026
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.157,
    x2: 239.429,
    xlinkHref: "#lg4",
    y1: 86.834,
    y2: 112.106
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.947,
    x2: 288.232,
    xlinkHref: "#lg5",
    y1: 123.639,
    y2: 80.154
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.112,
    x2: 429.385,
    xlinkHref: "#lg4",
    y1: 122.52,
    y2: 147.793
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.902,
    x2: 478.187,
    xlinkHref: "#lg5",
    y1: 159.325,
    y2: 115.84
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.237,
    x2: 332.51,
    xlinkHref: "#lg4",
    y1: 10.731,
    y2: 36.004
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.027,
    x2: 381.312,
    xlinkHref: "#lg5",
    y1: 47.536,
    y2: 4.051
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m185.017 483.128h-96.875v-222.178c0-12.258 9.937-22.196 22.196-22.196h52.484c12.258 0 22.196 9.937 22.196 22.196v222.178z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.892 483.128h-96.875v-289.828c0-12.258 9.937-22.196 22.196-22.196h52.484c12.258 0 22.196 9.937 22.196 22.196v289.828z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.767 483.128h-96.875v-359.007c0-12.258 9.937-22.196 22.196-22.196h52.484c12.258 0 22.196 9.937 22.196 22.196v359.007z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.642 483.128h-96.875v-184.587c0-12.258 9.937-22.196 22.196-22.196h52.484c12.258 0 22.196 9.937 22.196 22.196v184.587z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m281.892 483.128v-125.303l-96.875-96.875v222.178z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.767 483.128v-192.953l-96.875-96.875v289.828z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.475 293.068.502-1.707c-.191.559-.355 1.129-.502 1.707z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.985 295.593c-.129.967-.218 1.946-.218 2.948v184.587h96.875v-90.878z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.872 510c-14.841 0-26.872-12.031-26.872-26.872v-456.256c0-14.841 12.031-26.872 26.872-26.872 14.841 0 26.872 12.031 26.872 26.872v456.256c0 14.841-12.031 26.872-26.872 26.872z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 483.128c0-14.841 12.031-26.872 26.872-26.872h456.256c14.841 0 26.872 12.031 26.872 26.872 0 14.841-12.031 26.872-26.872 26.872h-456.256c-14.841 0-26.872-12.031-26.872-26.872z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m134.111 203.3c-2.902 0-5.78-1.257-7.757-3.683-3.489-4.28-2.848-10.58 1.434-14.069l195.974-159.727c4.155-3.387 10.249-2.895 13.805 1.123l100.575 113.588c3.661 4.135 3.276 10.455-.858 14.116-4.134 3.66-10.455 3.277-14.116-.858l-94.211-106.4-188.534 153.662c-1.856 1.511-4.091 2.248-6.312 2.248z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 138.17,
    cy: 191.799,
    fill: "url(#SVGID_12_)",
    r: 25.491
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.353 169.403c1.973 3.62 3.095 7.77 3.095 12.183 0 14.078-11.413 25.491-25.491 25.491-4.413 0-8.563-1.122-12.183-3.095 4.322 7.928 12.73 13.308 22.396 13.308 14.078 0 25.491-11.413 25.491-25.491 0-9.666-5.38-18.074-13.308-22.396z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 237.25,
    cy: 109.926,
    fill: "url(#SVGID_14_)",
    r: 25.491
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.432 87.53c1.973 3.62 3.095 7.77 3.095 12.183 0 14.078-11.413 25.491-25.491 25.491-4.413 0-8.563-1.122-12.183-3.095 4.322 7.928 12.73 13.308 22.396 13.308 14.078 0 25.491-11.413 25.491-25.491.001-9.665-5.379-18.074-13.308-22.396z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 427.205,
    cy: 145.613,
    fill: "url(#SVGID_16_)",
    r: 25.491
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.388 123.217c1.973 3.62 3.095 7.77 3.095 12.183 0 14.078-11.413 25.491-25.491 25.491-4.413 0-8.563-1.122-12.183-3.095 4.322 7.928 12.73 13.308 22.396 13.308 14.078 0 25.491-11.413 25.491-25.491 0-9.665-5.38-18.074-13.308-22.396z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 330.33,
    cy: 33.824,
    fill: "url(#SVGID_18_)",
    r: 25.491
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.513 11.428c1.973 3.62 3.095 7.77 3.095 12.183 0 14.078-11.413 25.491-25.491 25.491-4.413 0-8.563-1.122-12.183-3.095 4.322 7.928 12.73 13.308 22.396 13.308 14.078 0 25.491-11.413 25.491-25.491 0-9.665-5.38-18.074-13.308-22.396z",
    fill: "url(#SVGID_19_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarGraph);
export default __webpack_public_path__ + "static/media/icon-bar-graph.c089cf17fb57ff3048192661b4d457e7.svg";
export { ForwardRef as ReactComponent };